import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';
import type { QuestionApiModel } from '@visiba/api-vcs-client-v2';
import type { FormOption, ValidOptionId } from './_form_option';
import { FormQuestionBase } from './_form_question_base';

export class FormQuestionTypeMultiChoice extends FormQuestionBase {
	public readonly type = 'MultiChoice';
	public readonly options: FormOption[];
	public defaultValue: ValidOptionId[] | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);

		// TODO PAT-426: Allow null?
		this.options = this.parseQuestions(question.Options ?? []);
	}

	// TODO: Use this when not injected anymore...
	// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		const choices: number[] = [];

		const answers = pageData[this.id] ?? [];

		for (const option of this.options) {
			const isChecked = answers.includes(option.id);
			if (!isChecked) continue;

			choices.push(option.composeOptionId(option.id));
		}

		return this.createAnswerApiModel({
			choices,
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());
		const options = this.options.filter((option) => answer?.choices?.includes(option.composeOptionId()));
		this.defaultValue = options.map((option) => option.id) ?? undefined;
	}
}
